import type { SVGProps } from 'react';

const KeywordGapIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    {...props}
  >
    <ellipse cx="30" cy="30" rx="30" ry="30" fill="currentColor" />
    <path
      d="M44.3945 15L41.1836 18.2109M41.1836 18.2109L46 23.0273L40.3809 28.6465L35.5645 23.8301M41.1836 18.2109L35.5645 23.8301M28.966 30.4285C29.795 31.2465 30.454 32.2203 30.905 33.2939C31.3561 34.3676 31.5903 35.5199 31.5942 36.6844C31.5981 37.849 31.3716 39.0028 30.9278 40.0795C30.4839 41.1561 29.8315 42.1343 29.008 42.9578C28.1845 43.7813 27.2063 44.4337 26.1296 44.8776C25.053 45.3214 23.8992 45.5479 22.7346 45.544C21.5701 45.5401 20.4178 45.3059 19.3441 44.8548C18.2705 44.4038 17.2966 43.7448 16.4787 42.9158C14.8702 41.2505 13.9802 39.02 14.0003 36.7048C14.0205 34.3895 14.9491 32.1749 16.5863 30.5377C18.2234 28.9005 20.4381 27.9719 22.7533 27.9518C25.0685 27.9316 27.299 28.8217 28.9644 30.4301L28.966 30.4285ZM28.966 30.4285L35.5645 23.8301"
      stroke="#2563EB"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default KeywordGapIcon;
